module.exports = __webpack_public_path__ + "img/pdf.ecb9bcd3.png";